export const DOJO_CLIENT_SCRIPT_URL = 'https://cdn.dojo.tech/payments/v1/client.js'

export interface DojoPaymentResult {
    statusCode: number
    authCode?: string
    message?: string
}

export interface DojoValidationError {
    message?: string
}

export interface DojoPaymentDetails {
    paymentToken: string
}

export type DojoCssProperties = Record<string, string>

export interface DojoFieldStyleConfiguration {
    default?: DojoCssProperties
    focus?: DojoCssProperties
    error?: DojoCssProperties
    valid?: DojoCssProperties
    errorFocus?: DojoCssProperties
    validFocus?: DojoCssProperties
    container?: DojoCssProperties
    label?: DojoCssProperties
    validationText?: DojoCssProperties
    validationIcon?: DojoCssProperties
}

export interface DojoCardStylesConfiguration {
    base: DojoFieldStyleConfiguration
    cardName?: DojoFieldStyleConfiguration
    cardNumber?: DojoFieldStyleConfiguration
    expiryDate?: DojoFieldStyleConfiguration
    cv2?: DojoFieldStyleConfiguration
    cardIcon?: DojoCssProperties
    form?: DojoCssProperties
}

export interface DojoFieldTextConfiguration {
    label: string
    placeholder: string
    showValidation?: boolean
}

export interface DojoCardTextConfiguration {
    cardName?: DojoFieldTextConfiguration
    cardNumber?: DojoFieldTextConfiguration
    expiryDate?: DojoFieldTextConfiguration
    cv2?: DojoFieldTextConfiguration
}

export interface DojoCardErrorMessages {
    cardNameRequired?: string
    cardNameInvalid?: string
    cardNumberRequired?: string
    cardNumberInvalid?: string
    expiryDateRequired?: string
    expiryDateInvalid?: string
    expiryDateMustBeInFuture?: string
    cv2Required?: string
    cv2Invalid?: string
}

export interface DojoCardConfiguration {
    containerId: string
    paymentDetails: DojoPaymentDetails
    fontCss?: string[]
    styles: DojoCardStylesConfiguration
    text?: DojoCardTextConfiguration
    errorMessages?: DojoCardErrorMessages
    callbacks: {
        onFormComplete: (isComplete?: boolean) => void
    }
    onIframeLoaded: () => void
    onIframeLoadFailed: () => void
}

export interface DojoCard {
    executePayment(additionalInfo?: {
        userEmailAddress?: string
    }): Promise<DojoPaymentResult>
    updateAccessToken(details: DojoPaymentDetails): void
}

export interface DojoWalletConfiguration {
    containerId: string
    paymentDetails: DojoPaymentDetails
    buttonConfig: {
        color: 'black'
        type: 'plain'
        sizeMode: 'fill'
    }
    emailRequired: boolean
    billingAddressRequired: boolean
    shippingAddressRequired: boolean
}

export interface DojoWallet {
    updateAccessToken(details: DojoPaymentDetails): void
}

export interface DojoClient {
    Payment: new (
        configuration: DojoCardConfiguration,
        displayErrors: (errors: DojoValidationError[]) => void,
        onSubmitTriggered: () => void,
        onBlur: (isValid: boolean) => void
    ) => DojoCard
    WalletPayment: new (
        configuration: DojoWalletConfiguration,
        displayErrors: (errors: DojoValidationError[]) => void,
        paymentComplete: (result: DojoPaymentResult) => void
    ) => DojoWallet
}

export type DojoWindow = Window & typeof globalThis & {
    Dojo?: DojoClient
}
